/**
 * Imágenes optimizadas a través de wsrv.nl (CDN público de imágenes):
 * redimensiona al ancho exacto, convierte a WebP y sirve con caché larga.
 * Así el navegador descarga solo los píxeles que realmente se ven.
 */
const PROXY = 'https://wsrv.nl/'
export const IMAGE_PROXY_ORIGIN = 'https://wsrv.nl'

export function optimizedImage(src: string, width: number, quality = 72): string {
  const params = new URLSearchParams({
    url: src,
    w: String(width),
    output: 'webp',
    q: String(quality),
    we: '', // sin agrandar por encima del original
  })
  return `${PROXY}?${params.toString()}`
}

export function optimizedSrcSet(src: string, widths: number[], quality = 72): string {
  return widths.map((w) => `${optimizedImage(src, w, quality)} ${w}w`).join(', ')
}

/** Anchos y `sizes` de la imagen del hero (máx. 672 px de ancho visible). */
export const HERO_WIDTHS = [400, 640, 800, 1200]
export const HERO_SIZES =
  '(min-width: 1024px) 672px, (min-width: 640px) 576px, min(384px, calc(100vw - 48px))'

/** Portadas de los bonus: 64 px en móvil, 96 px desde sm. */
export const BONUS_WIDTHS = [128, 192]
export const BONUS_SIZES = '(min-width: 640px) 96px, 64px'
